import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

interface IGlobalSearchContextProps {
  isGlobalSearchResultsPanelOpen: boolean;
  setIsGlobalSearchResultsPanelOpen: Dispatch<SetStateAction<boolean>>;
}

const GlobalSearchContext = createContext<IGlobalSearchContextProps>({
  isGlobalSearchResultsPanelOpen: false,
  setIsGlobalSearchResultsPanelOpen: () => null,
});

const GlobalSearchContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isGlobalSearchResultsPanelOpen, setIsGlobalSearchResultsPanelOpen] =
    useState(false);

  return (
    <GlobalSearchContext.Provider
      value={{
        isGlobalSearchResultsPanelOpen,
        setIsGlobalSearchResultsPanelOpen,
      }}
    >
      {children}
    </GlobalSearchContext.Provider>
  );
};

const useGlobalSearchContext = () => useContext(GlobalSearchContext);

export { GlobalSearchContextProvider, useGlobalSearchContext };
